// extracted by mini-css-extract-plugin
export default {"root":"quote-module--root--b277e","quoteMark":"quote-module--quote-mark--025cf","blockQuote":"quote-module--block-quote--4e5be","source":"quote-module--source--c173d"};